import { Exclude, Expose, Type } from 'class-transformer'

import { MyWritingListType } from './MyWritingListType'

@Exclude()
export class MyWritingResponse {
  @Expose()
  @Type(() => MyWritingListType)
  data: MyWritingListType[]

  @Expose()
  total: number

  @Expose()
  page: number
}
